import { EVENT_TYPE } from '@lighthouse/core'
import type { FlowNode, FlowNodeResultADT } from '@lighthouse/shared'

import type { ExecuteActionParams } from '../type'

export const handleRefreshUserPermissions = async (
    node: FlowNode,
    params: ExecuteActionParams
): Promise<undefined | FlowNodeResultADT> => {
    const { actionEvents, eventType } = params

    if (eventType !== EVENT_TYPE.LOAD_DATA && eventType !== EVENT_TYPE.LOAD) {
        await actionEvents.refreshUserPermissions?.()
    }

    return Promise.resolve({
        type: 'record',
        success: true
    })
}
